(() => {
  const KEYS = [
    ['part', /part/i],
    ['dia', /^(dia|diameter)/i],
    ['tooth', /^(tooth|teeth)/i],
    ['grind', /^grind/i],
    ['plate', /^plate/i],
    ['kerf', /^kerf/i],
    ['bore', /^bore/i],
  ];

  function text(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function parseSpecTable(root) {
    const table = root.querySelector('table.tablepress, .product__description table, .rte table');
    if (!table) return {};
    const headerCells = [...table.querySelectorAll('thead th, tr:first-child th, tr:first-child td')];
    if (!headerCells.length) return {};
    const idx = {};
    headerCells.forEach((cell, i) => {
      const t = text(cell);
      for (const [key, re] of KEYS) {
        if (idx[key] == null && re.test(t)) idx[key] = i;
      }
    });
    if (idx.part == null) return {};
    const map = {};
    const rows = [...table.querySelectorAll('tbody tr')];
    const source = rows.length ? rows : [...table.querySelectorAll('tr')].slice(1);
    source.forEach((tr) => {
      const cells = [...tr.querySelectorAll('td')];
      if (!cells.length) return;
      const part = text(cells[idx.part]);
      if (!part) return;
      const rec = {};
      for (const [key] of KEYS) {
        if (idx[key] != null && cells[idx[key]]) rec[key] = text(cells[idx[key]]);
      }
      const norm = part.replace(/\s+/g, '').replace(/\*+$/, '');
      map[part] = rec;
      map[norm] = rec;
      map[norm.toUpperCase()] = rec;
    });
    return map;
  }

  function currentVariant(picker) {
    const script = picker.querySelector('script[type="application/json"]');
    if (!script) return null;
    let variants = [];
    try { variants = JSON.parse(script.textContent || '[]'); } catch (e) { return null; }
    const options = [];
    picker.querySelectorAll('fieldset').forEach((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) options.push(checked.value);
    });
    picker.querySelectorAll('select').forEach((sel) => options.push(sel.value));
    return variants.find((v) => {
      const vo = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
      return vo.length === options.length && vo.every((o, i) => o === options[i]);
    }) || variants[0] || null;
  }

  function applyHints(picker, specMap) {
    picker.querySelectorAll('label').forEach((label) => {
      const input = document.getElementById(label.getAttribute('for'));
      const value = input ? input.value : text(label);
      const rec = specMap[value] || specMap[(value || '').replace(/\s+/g, '').replace(/\*+$/, '')];
      if (!rec) return;
      const hint = [rec.dia, rec.tooth, rec.grind].filter(Boolean).join(' · ');
      if (!hint) return;
      label.setAttribute('title', hint);
      if (!label.querySelector('.nordic-option-hint')) {
        // Keep pills compact: tooltip only. Selected panel carries the row.
      }
    });
    picker.querySelectorAll('option').forEach((opt) => {
      const value = opt.getAttribute('value') || '';
      const rec = specMap[value] || specMap[value.replace(/\s+/g, '').replace(/\*+$/, '')];
      if (!rec) return;
      const hint = [rec.dia, rec.tooth, rec.grind].filter(Boolean).join(' ');
      if (!hint) return;
      if (!opt.dataset.nordicHinted) {
        opt.textContent = `${value} — ${hint}`;
        opt.dataset.nordicHinted = '1';
      }
    });
  }

  function renderPanel(panel, variant, specMap) {
    if (!panel) return;
    const sku = (variant && (variant.sku || (variant.options && variant.options[0]) || variant.option1 || variant.name)) || '';
    const skuEl = panel.querySelector('[data-nordic-spec="sku"]');
    if (skuEl) skuEl.textContent = sku || '—';
    const rec = specMap[sku] || specMap[(sku || '').replace(/\s+/g, '').replace(/\*+$/, '')] || {};
    const grid = panel.querySelector('[data-nordic-spec-grid]');
    const keys = ['dia', 'tooth', 'grind', 'plate', 'kerf', 'bore'];
    let any = false;
    keys.forEach((k) => {
      const el = panel.querySelector(`[data-nordic-spec="${k}"]`);
      if (el) el.textContent = rec[k] || '—';
      if (rec[k]) any = true;
    });
    if (grid) grid.hidden = !any;
  }

  function bind(picker) {
    if (picker.dataset.nordicBound) return;
    picker.dataset.nordicBound = '1';
    const section = picker.closest('.product, product-info, section') || document;
    const specMap = parseSpecTable(section) || parseSpecTable(document);
    const panel = (picker.parentElement && picker.parentElement.querySelector('[data-nordic-selected-specs]'))
      || document.querySelector('[data-nordic-selected-specs]');
    applyHints(picker, specMap);
    const update = () => renderPanel(panel, currentVariant(picker), specMap);
    picker.addEventListener('change', update);
    update();
  }

  function init() {
    document.querySelectorAll('[data-nordic-picker], variant-radios, variant-selects').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
